import { useState } from "react";
import { exportToExcel } from "../../Services/Export/SaveDataAsExcel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faFileWord, IconDefinition } from "@fortawesome/free-solid-svg-icons";

import "./Style/ExportButton.css";

type ExportButtonProps<T> = {
  data: T[];
  filename: string;
  format: IconKey
};

type IconKey = "xlsx" | "doc" | "pdf"

const iconMapping: Record<IconKey, IconDefinition> = {
  xlsx: faFileExcel,
  doc: faFileWord,
  pdf: faFilePdf
}

export const ExportButton = <T extends Record<string, any>>({data, filename, format}: ExportButtonProps<T>) => {
  const [icon] = useState(iconMapping[format]);
  return (
    <button className="export-button" onClick={()=> exportToExcel(data, filename, 'Produtos')}>
      <FontAwesomeIcon icon={icon} color="var(--success)" size="2x"></FontAwesomeIcon>
    </button>
  )
}

export default ExportButton